const revealNewsletterButton_animation = document.querySelector( '[data-reveal-newsletter]' );
const closeNewsletterButton_animation = document.querySelector( '[data-close-newsletter]' );
const newsletterSignup_animation = document.querySelector( '.animation-newsletter' );

const toggleAnimationNewsletter = () => {
	if ( ! newsletterSignup_animation.classList.contains( 'active' ) ) {
		/** Show the container. */
		newsletterSignup_animation.classList.add( 'active' );
		newsletterSignup_animation.style.height = "auto";

		/** Get the computed height of the container. */
		var height = newsletterSignup_animation.clientHeight + "px";


		/** Set the height of the content as 0px, */
		/** so we can trigger the slide down animation. */
		newsletterSignup_animation.style.height = "0px";

		/** Do this after the 0px has applied. */
		/** It's like a delay or something. MAGIC! */
		setTimeout(() => {
			newsletterSignup_animation.style.height = height
		}, 50);

	/** Slide up. */
	} else {
		/** Set the height as 0px to trigger the slide up animation. */
		newsletterSignup_animation.style.height = "0px";

		/** Remove the `active` class when the animation ends. */
		newsletterSignup_animation.addEventListener( 'transitionend', () => {
			newsletterSignup_animation.classList.remove( 'active' );
		}, { once: true } );
	}
}

revealNewsletterButton_animation.addEventListener( 'click', toggleAnimationNewsletter );
closeNewsletterButton_animation.addEventListener( 'click', toggleAnimationNewsletter );
